/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getTrustpilotUrlPayload} from '../api'

 export const useQueryGetTrustpilotUrlPayload = createReactQueryHook('getTrustpilotUrlPayload', getTrustpilotUrlPayload)
